import ApiError from '../../../../entities/api-error/ApiError'
import { OrderProduct } from '../../../../entities/order-product/OrderProduct'
import DashboardActionTypes from './DashboardActionTypes'

export interface RequestReprint {
  type: DashboardActionTypes.REQUEST_REPRINT;
  payload: {
    product: OrderProduct
  }
}

export function requestReprint({
  product,
}: RequestReprint['payload']): RequestReprint {
  return {
    type: DashboardActionTypes.REQUEST_REPRINT,
    payload: {
      product,
    },
  }
}

export interface RequestReprintSuccess {
  type: DashboardActionTypes.REQUEST_REPRINT_SUCCESS;
  payload: {
    product: OrderProduct
  }
}

export function requestReprintSuccess({
  product,
}: RequestReprintSuccess['payload']): RequestReprintSuccess {

  return {
    type: DashboardActionTypes.REQUEST_REPRINT_SUCCESS,
    payload: {
      product,
    },
  }
}

export interface RequestReprintFailure {
  type: DashboardActionTypes.REQUEST_REPRINT_FAILURE;
  payload: {
    product: OrderProduct
    error: ApiError
  }
}

export function requestReprintFailure({
  product,
  error,
}: RequestReprintFailure['payload']): RequestReprintFailure {

  return {
    type: DashboardActionTypes.REQUEST_REPRINT_FAILURE,
    payload: {
      product,
      error,
    },
  }
}
